import { mergeRight } from 'ramda';
import { Component } from 'react';
import Modal from 'react-modal';

import { FormModal } from '../../components';

import s from './HostStyles.module.scss';

const options = (selected, handleSubmit, handleClose) => {
    const OPTIONS = {
        profile: {
            textOptions: [
                { label: 'email', value: 'email' },
                { label: 'First Name', value: 'firstName' },
                { label: 'Last Name', value: 'lastName' },
            ],
            buttonText: 'Update Profile',
            handleSubmit,
            handleClose,
            title: 'Edit Profile',
        },
        password: {
            textOptions: [
                { label: 'Old Password', value: 'oldPassword', password: true },
                { label: 'New Password', value: 'newPassword', password: true },
                { label: 'New Password Confirmed', value: 'newPasswordConfirmed', password: true },
            ],
            buttonText: 'Change Password',
            handleSubmit,
            handleClose,
            title: 'Change Password',
        },
    };
    return OPTIONS[selected];
};

export default class FormHost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            selectedOption: 'profile',
            bannerOption: 'red',
            profileModalValues: {
                firstName: 'Test',
                lastName: 'VMS',
                email: 'test@test.com',
                oldPassword: '',
                newPassword: '',
                newPasswordConfirmed: '',
                code: '',
                description: '',
            },
        };
    }

    openModal = () => {
        this.setState({ isOpen: true });
    };
    closeModal = () => this.setState({ isOpen: false });

    onChange = changes => {
        const { profileModalValues } = this.state;
        const updates = mergeRight(profileModalValues, changes);

        this.setState({ profileModalValues: updates });
    };
    handleSubmit = () => {
        console.log(this.state.profileModalValues);

        this.closeModal();
    };
    handleOptionChange = changeEvent => {
        this.setState({ selectedOption: changeEvent.target.value });
    };
    handleBannerChange = changeEvent => {
        this.setState({ bannerOption: changeEvent.target.value });
    };
    renderInputForm = () => (
        <form className={s.formHost} onSubmit={() => {}} style={{ margin: '10px' }}>
            <div>Input Options</div>
            <input type="radio" value="profile" name="options" checked={this.state.selectedOption === 'profile'} onChange={this.handleOptionChange} />
            Profile
            <br />
            <input type="radio" value="password" name="options" checked={this.state.selectedOption === 'password'} onChange={this.handleOptionChange} />
            Password
            <br />
        </form>
    );
    bannerOptions = () => (
        <form className={s.formHost} onSubmit={() => {}} style={{ margin: '10px' }}>
            <div>Banner Options</div>
            <input type="radio" value="red" name="bannerOption" checked={this.state.bannerOption === 'red'} onChange={this.handleBannerChange} />
            Red
            <br />
            <input type="radio" value="green" name="bannerOption" checked={this.state.bannerOption === 'green'} onChange={this.handleBannerChange} />
            Green
            <br />
            <input type="radio" value="" name="bannerOption" checked={this.state.bannerOption === ''} onChange={this.handleBannerChange} />
            None
            <br />
        </form>
    );
    determineBanner = () => {
        const { bannerOption } = this.state;

        switch (bannerOption) {
            case 'red':
                return { message: 'Error', color: 'red', icon: 'icon-lock', isVisible: true };
            case 'green':
                return { message: 'Success!', color: 'green', icon: 'icon-circle-check', isVisible: true };
            default:
                return { message: 'error?', color: 'green', icon: 'icon-lock', isVisible: false };
        }
    };
    render() {
        const { isOpen } = this.state;

        const banner = this.determineBanner();

        return (
            <div className={s.editor}>
                <button type="button" onClick={this.openModal}>
                    Show Form
                </button>
                {this.renderInputForm()}
                {this.bannerOptions()}
                <Modal className={s.modal} overlayClassName={s.overlay} isOpen={isOpen}>
                    <FormModal
                        banner={banner}
                        handleChange={this.onChange}
                        options={options(this.state.selectedOption, this.handleSubmit, this.closeModal)}
                        editableValues={this.state.profileModalValues}
                    />
                </Modal>
            </div>
        );
    }
}
